import React from 'react';
import { observer } from 'mobx-react';
import C3Chart from 'react-c3js';

import Panel from '../../commons/Panel';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Espontaneo extends React.Component {
  componentWillMount() {
    UIStore.init('Gráfico Espontâneo', null, null, false, () =>
      SelecaoStore.loadCandidatos('ESPONTANEO')
    );
    SelecaoStore.candidatos = [];
    SelecaoStore.loadCandidatos('ESPONTANEO');
  }

  render() {
    this.candidatos = [...SelecaoStore.candidatos];
    this.candidatos.sort(
      (c1, c2) =>
        (!c2.candidato ? -100.0 : c2.media) -
        (!c1.candidato ? -100.0 : c1.media)
    );
    let vagas = {
      type: 'bar',
      labels: true,
      x: 'candidato',
      columns: [
        [
          'candidato',
          ...this.candidatos.map(c => [
            c.candidato
              ? c.candidato.nome
              : c.tipo === 'NAO_VOTARA'
                ? 'Não Votarão'
                : c.tipo[0] + c.tipo.substring(1).toLowerCase() + 's',
          ]),
        ],
        ['total', ...this.candidatos.map(c => [c.media])],
      ],
      color: (color, d) => {
        return this.candidatos[d.x] && this.candidatos[d.x].candidato
          ? this.candidatos[d.x].candidato.partido.cor
          : '#ccc';
      },
    };

    return (
      <React.Fragment>
        <Panel
          title="Espontâneo"
          loadHistory={() =>
            EvolucaoStore.loadCandidatosMajoritarios('ESPONTANEO')
          }
        >
          <C3Chart
            key={'espontaneo-chart'}
            style={{ height: '520px', maxHeight: '520px' }}
            data={vagas}
            axis={{ rotated: true, x: { type: 'category' } }}
            legend={{ show: false }}
          />
        </Panel>
        <EvolucaoDialog
          title="Evolução do Candidato"
          opened={EvolucaoStore.candidatos != null}
          data={EvolucaoStore.candidatos}
          onOK={() => (EvolucaoStore.candidatos = null)}
          columnFunc={col =>
            col === 'NAO_VOTARA'
              ? 'Não Votarão'
              : col === 'INDECISO'
                ? 'Indecisos'
                : col === 'BRANCO'
                  ? 'Brancos'
                  : col === 'NULO'
                    ? 'Nulos'
                    : col
          }
        />
      </React.Fragment>
    );
  }
}

export default observer(Espontaneo);



// WEBPACK FOOTER //
// ./src/components/majoritario/espontaneo/index.js